// AGENT-A4: DATE RANGE segmented control — toggles `filterStore.dateRange.kind`
// between "fy" (the FY-list behaviour) and "dynamic" (no date filter emitted
// at all; the server's intrinsic page-level dates take over).
//
// Two-pill segmented control, same visual styling as BooleanToggle /
// TriBooleanToggle. Stateless — reads/writes through the filterStore via the
// caller-supplied `value` / `onChange` props so the control stays consistent
// with the rest of the filter-bar contract.

export interface DateRangeToggleProps {
  value: "fy" | "dynamic";
  onChange: (v: "fy" | "dynamic") => void;
  header?: string;
  ariaLabel?: string;
  labels?: [string, string];
}

export function DateRangeToggle(props: DateRangeToggleProps): JSX.Element {
  const { value, onChange, header, ariaLabel, labels } = props;
  const [fyLabel, dynamicLabel] = labels ?? ["FY", "Dynamic"];

  return (
    <div className="dash-filter-field">
      {header ? <span className="dash-filter-field__header">{header}</span> : null}
      <div
        className="dash-segmented"
        role="group"
        aria-label={ariaLabel ?? header ?? "Date Range"}
      >
        <button
          type="button"
          className={`dash-segmented__pill${
            value === "fy" ? " dash-segmented__pill--active" : ""
          }`}
          onClick={() => onChange("fy")}
          aria-pressed={value === "fy"}
        >
          {fyLabel}
        </button>
        <button
          type="button"
          className={`dash-segmented__pill${
            value === "dynamic"
              ? " dash-segmented__pill--active dash-segmented__pill--dynamic-on"
              : ""
          }`}
          onClick={() => onChange("dynamic")}
          aria-pressed={value === "dynamic"}
          title="No date filter — show all periods, or set a custom From/To window below"
        >
          {dynamicLabel}
        </button>
      </div>
    </div>
  );
}

export default DateRangeToggle;
